// @flow
//eslint-disable-next-line

import * as React from 'react'

function LoadingAnimation() {
	return (
		<>
			<div className="screen midWrap bg-white">
				<div className="container">
					<div className="row">
						<div className="col-sm-12">
							<div className="home-loading">
								<div className="home-heading">Loading {process.env.REACT_APP_LOADING_TEXT}</div>
								<div className="loading-anim">
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
export default LoadingAnimation
